import React, { useEffect, useState } from 'react';
import { Modal, Table, Flex } from 'antd';
import { mixPostV1 } from '../../../services/mixin';
import './PaymentHistoryModal.scss';

interface Props {
    isShow: boolean;
    storeId: string;
    onClose: () => void;
}

const PaymentHistoryModal: React.FC<Props> = ({ isShow, storeId, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [paymentHistory, setPaymentHistory] = useState<any[]>([]);
    const [paymentInfo, setPaymentInfo] = useState<any>(null);

    useEffect(() => {
        if (isShow && storeId) {
            setLoading(true);
            setPaymentHistory([]);
            setPaymentInfo(null);
            mixPostV1('/api/webAdmin/gListHistorypaymentStore.php', { store_id: storeId })
                .then((res: any) => {
                    if (res.status === 1 && res.data) {
                        setPaymentHistory(res.data.historyPayment || []);
                        setPaymentInfo(res.data.infoPlanStore || null);
                    }
                })
                .finally(() => setLoading(false));
        }
    }, [isShow, storeId]);

    return (
        <Modal
            open={isShow}
            onCancel={onClose}
            footer={null}
            title={null}
            width={600}
            modalRender={modal => <div className="payment-history-modal-dark">{modal}</div>}
        >
            <div className="phm-title">Payment history</div>
            <Flex justify="space-between" style={{ marginBottom: 8 }} className="phm-info-row">
                <div>
                    <div><b>Store:</b> {paymentInfo?.store_name || '-'}</div>
                    <div><b>Owner:</b> {paymentInfo?.owner_name || '-'}</div>
                </div>
                <div>
                    <div><b>Type:</b> {paymentInfo?.type_name || '-'}</div>
                    <div><b>Phone number:</b> {paymentInfo?.phone_number || '-'}</div>
                </div>
            </Flex>
            <Table
                dataSource={paymentHistory.map((item, idx) => ({
                    key: idx,
                    date: item.date_payment,
                    amount: item.amount,
                    method: item.pay_method,
                    status_pay: item.status_pay,
                    reason_fail: item.reason_fail
                }))}
                columns={[
                    { title: 'Date', dataIndex: 'date', key: 'date', align: 'center' },
                    { title: 'Amount', dataIndex: 'amount', key: 'amount', align: 'center' },
                    { title: 'Payment method', dataIndex: 'method', key: 'method', align: 'center' },
                    {
                        title: 'Status',
                        dataIndex: 'status_pay',
                        key: 'status_pay',
                        align: 'center',
                        render: (status: number) => status === 1 ? <span style={{ color: 'green', fontWeight: 500 }}>Success</span> : <span style={{ color: 'red', fontWeight: 500 }}>Failed</span>
                    },
                    {
                        title: 'Reason fail',
                        dataIndex: 'reason_fail',
                        key: 'reason_fail',
                        align: 'center',
                        render: (text: string, record: any) => record.status_pay === 0 && text ? <span style={{ color: 'red' }}>{text}</span> : null
                    }
                ]}
                pagination={false}
                bordered={false}
                loading={loading}
                style={{ marginTop: 8 }}
                locale={{ emptyText: loading ? 'Loading...' : 'No data' }}
            />
        </Modal>
    );
};

export default PaymentHistoryModal;